import { render, staticRenderFns } from "./Activate.html?vue&type=template&id=07fc3170&scoped=true&"
import script from "./Activate.ts?vue&type=script&lang=ts&"
export * from "./Activate.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/checkout/_errors.scss?vue&type=style&index=0&id=07fc3170&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc3170",
  null
  
)

export default component.exports